/**
 * AmountItemWrapper
 *  Encapsulates an AmountItem data object with a AmountItemConfig configuration object. Abstracts the setting and getting of the amount item value.
 **/
var AmountItemWrapper = /** @class */ (function () {
    /**
     * Create a new AmountItem wrapper.
     * @param item Item to wrap.
     * @param config Configuration settings.
     */
    function AmountItemWrapper(item, config) {
        if (!item) {
            throw new Error("Failed to initialize AmountItem: item must be provided.");
        }
        this._amountItem = item;
        this._config = config;
    }
    Object.defineProperty(AmountItemWrapper.prototype, "amount", {
        get: function () {
            if (this._amountItem.isComputed) {
                this._amountItem.amount = this._config.computation();
            }
            return this._amountItem.amount;
        },
        set: function (modifiedValue) {
            this._amountItem.amount = modifiedValue;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AmountItemWrapper.prototype, "isComputed", {
        get: function () {
            return this._amountItem.isComputed;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AmountItemWrapper.prototype, "isRequired", {
        get: function () {
            return this._amountItem.isRequired;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AmountItemWrapper.prototype, "isReadOnly", {
        get: function () {
            return this._amountItem.isReadOnly;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AmountItemWrapper.prototype, "type", {
        get: function () {
            return this._amountItem.type;
        },
        set: function (modifiedValue) {
            this._amountItem.type = modifiedValue;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AmountItemWrapper.prototype, "validationRules", {
        get: function () {
            return this._config.rules;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AmountItemWrapper.prototype, "columnKey", {
        get: function () {
            return this._amountItem.columnKey;
        },
        enumerable: false,
        configurable: true
    });
    AmountItemWrapper.prototype.validateWith = function (rules) {
        this._config.rules = rules;
    };
    AmountItemWrapper.prototype.computeWith = function (computation) {
        this._config.computation = computation;
    };
    return AmountItemWrapper;
}());
export default AmountItemWrapper;
